import type {UserGroup} from '@/services/graphqlHooks';

const isGroupAuthorized = (
  currentGroups: UserGroup[],
  allowedGroups: UserGroup[]
) => !!currentGroups.filter(value => allowedGroups.includes(value)).length;

export default isGroupAuthorized;
